import React from "react";

interface Props {
  title: string;
  description: string;
}

export const SectionHeaderBlock: React.FC<Props> = ({ title, description }) => {
  return (
    <div className="h-full flex flex-col justify-center items-start max-sm:items-center py-2">
      {/* Small gradient rule above the title (Figma: 4x80px, primary → secondary). */}
      <div
        className="w-20 h-1 rounded-full mb-2 bg-gradient-to-r from-primary-button-background to-secondary-button-background"
        aria-hidden="true"
      />
      {/* Explicit px sizes: the iframe root pins font-size to 14px, so rem-based utilities
          render at 87.5% of nominal. Figma: 24px/600 title, 14px/500 description. */}
      <h2 className="text-[24px] leading-tight font-semibold text-main-foreground max-sm:text-center">
        {title}
      </h2>
      {description && (
        <p className="text-[14px] font-medium text-main-muted-foreground mt-1 leading-relaxed break-words overflow-hidden line-clamp-2 max-sm:text-center">
          {description}
        </p>
      )}
    </div>
  );
};
